
export default function Services() {
  const services = [
    {
      icon: "ri-lightbulb-line",
      title: "商品企画・開発",
      description: "市場ニーズに応じた美容商材の企画・開発を行います。お客様のご要望に合わせたオリジナル商品の開発も承ります。"
    },
    {
      icon: "ri-settings-3-line",
      title: "製造・品質管理",
      description: "厳格な品質管理のもと、安全で高品質な美容商材を製造いたします。ISO認証取得工場での製造で安心をお届けします。"
    },
    {
      icon: "ri-store-line",
      title: "卸売・小売販売",
      description: "美容サロン、エステサロン向けの卸売から、一般消費者向けの小売まで、幅広い販売チャネルでサービスを提供します。"
    },
    {
      icon: "ri-global-line",
      title: "通信販売事業",
      description: "全国のお客様に向けた通信販売事業を展開。オンラインショップでの販売から配送まで一貫してサポートいたします。"
    },
    {
      icon: "ri-customer-service-line",
      title: "アフターサポート",
      description: "商品購入後のアフターサポートも充実。使用方法のご相談から、商品に関するお悩みまで専門スタッフが対応いたします。"
    },
    {
      icon: "ri-graduation-cap-line",
      title: "技術指導・研修",
      description: "美容商材の正しい使用方法や最新の美容技術について、プロフェッショナル向けの技術指導・研修サービスを提供します。"
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-green-800 mb-4">
            <strong>サービス内容</strong>
          </h3>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            美容業界のあらゆるニーズにお応えする、総合的なサービスを提供いたします。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-yellow-50 p-6 rounded-lg border-2 border-yellow-400 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-green-800 rounded-full flex items-center justify-center mb-4">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <h4 className="text-xl font-bold text-green-800 mb-3">
                <strong>{service.title}</strong>
              </h4>
              <p className="text-gray-700 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-green-800 text-white p-8 rounded-lg">
          <div className="text-center">
            <h4 className="text-2xl font-bold mb-4">
              <strong>お客様のニーズに合わせたカスタマイズサービス</strong>
            </h4>
            <p className="text-lg mb-6 leading-relaxed">
              標準的なサービスに加えて、お客様の特別なご要望にお応えするカスタマイズサービスも承っております。
              まずはお気軽にご相談ください。
            </p>
            <a 
              href="#contact" 
              className="inline-block bg-yellow-500 text-green-800 px-8 py-3 rounded-lg hover:bg-yellow-400 transition-colors font-semibold whitespace-nowrap cursor-pointer"
            >
              カスタマイズ相談はこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
